"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var nameHexColors = {
  Beige: 'aa7e62',
  'Light Brown': 'ae8d79',
  'Medium Brown': '765845',
  'Dark Brown': '523e34',
  Black: '010208',
  'Classic Beige': 'ab8f73',
  'Classic Light Brown': '5f4d3e',
  'Classic Dark Brown': '2d231d',
  'Classic Light Grey': 'a4a89c',
  'Classic Dark Grey': '505252',
  Transparent: 'e2dfe0',
  Yellow: 'fbb400',
  Orange: 'ed5806',
  Pink: 'd44991',
  Purple: '5e19a1',
  Blue: '008cbf',
  Green: '00b2a3',
  'Classic Black': '1c1d1e',
  'Classic Baby Blue': 'e7e4ee',
  'Classic Baby Pink': 'f1bec2',
  'Baby Blue': 'd4ecf5',
  'Baby Pink': 'f1b9c6',
  Silver: 'e8eaef',
  'Cool Purple': '372669',
  Red: 'b5231d',
  'Cool Red': 'b5231d',
  Blue2: '1d4da4',
  'Cool Blue': '1d4da4',
  'Emerald Green': '009e0d',
  'Chroma Golden Beige': 'a2938a',
  'Chroma Ice Blue': 'a3b5bc',
  'Chroma Orchid': 'aeacba',
  'Chroma Copper': '2f1804',
  'Chroma Pearl White': 'e8eaef',
  'Chroma Steel Grey': '575858',
  'Chroma Silver Grey': 'afaca3',
  'Power Pink': 'c84a96',
  Aquamarine: '95d0dd',
  Champagne: 'bcbaaf',
  'Delta High Tech Silver': 'bdb5aa',
  'Charcoal Grey': '606062',
  'Diamond Black': '010208',
  'Chocolate Brown': '412418',
  'Champagne Beige': 'e7d0b1',
  'Mother of Pearl': 'fff4dd',
  'Midnight Blue': '021f45',
  'Royal Blue': '021f45',
  'Sunset Orange': 'ef5e14',
  'Delta Deep Purple': '362166',
  'Delta Green Chameleon': '445957',
  'Racing Green': '002e2d',
  'Cabernet Red': '5e060e',
  'Samoa Blue': 'b4dae6',
  'Shy Violet': 'dacdee',
  'Hear Pink': 'ffb8cd',
  'Black Line Chroma Beige': 'a2938a',
  'White Line Ice Blue': 'a3b5bc',
  'White Line Orchid': 'aeacba',
  'Black Line Espresso': '2f1804',
  'Black Line White Silver': 'e8ebe9',
  'Black Line Steel Grey': '575858',
  'White Line Silver Grey': 'afaca3',
  'White Line Gold Dust': 'e9cba3',
  'Chroma Beige': 'a2938a',
  'Silver Grey': 'afaca3',
  'Steel Grey': '575858',
  'Chestnut Brown': '533a28',
  Terracotta: '7f6857',
  'Vivid Lilac': '79658e',
  'Natural Henna': '723329',
  'Pure White': 'eaf1ec',
  'Pale Lime': 'e7f07e',
  'Transparent Red': 'd84b47',
  'Transparent Blue': '4d64b7',
  'Think Pink': 'ffb8cd',
  White: 'ffffff',
  'Jet Black': '010208',
  'Metallic Silver': 'afaca3',
  'Metallic Anthracite': '444b4c',
  'Cocoa Brown': '533a28',
  'Sand Beige': 'a2938a',
  'Antique Bronze': '7f6857',
  'Cobalt Blue': '02314c',
  'Dark Brown2': '535047',
  'Grey Brown': '817a72',
  Graphite: '5c5f5e',
  Beige2: 'b99376',
  Gray: 'abb0b1',
  'Metallic Beige': 'ccb48e',
  'Baby Blue2': 'd4ecf5',
  'Baby Pink2': 'f1b9c6',
  Taupe: '7f6857',
  Brown: '533a28',
  'Dark Grey': '575858',
  Grey: 'afaca3',
  Beige3: 'a2938a',
  Black2: '010208'
};

var resolveColor = function resolveColor(name) {
  return "#".concat(nameHexColors[name]) || '#000000';
};

var _default = resolveColor;
exports["default"] = _default;